module.exports = __webpack_public_path__ + "img/artist-img-4.629287bf.jpg";